import { log } from "@/utils/logger";
import { useQuery } from "@tanstack/react-query";
import { useUser } from "@/context/user";
import { Organization } from "@/types/entities";
import { Role } from "@/types/utils";
import api from "@/config/api";

const useQueryOrganizations = () => {
    const authenticated = useUser(state => state.authenticated);

    const getOrganizations = async () => {
        try {
            const data =
                await api.get<Record<string, { role: Role; organization: Organization }>>(
                    "/organizations",
                );

            return data;
        } catch (e) {
            log.error(e, "getOrganizations");
        }
    };

    return useQuery({
        queryKey: ["organizations"],
        queryFn: getOrganizations,
        enabled: authenticated,
    });
};

export default useQueryOrganizations;
